import { UsersApi } from "@socotec.io/user-management-sdk";
import { userManagementConfig } from "@/setup/openApiConfig";

const usersApi = new UsersApi(userManagementConfig);

export const UserManagementClient = {
  list: async ({ filters = {} } = {}) => {
    const response = await usersApi.list(filters);
    return { ...response, results: response.results || [] };
  },
  retrieve: async ({ uuid }) => {
    return await usersApi.retrieve({ uuid });
  },
};
